import React, { SFC } from 'react'

// TODO: Add styles for table row
// import './TableRow.scss'

type Props = {
  className?: string
}

const TableRow: SFC<Props> = ({ children, className }) => {
  return <tr className={className}>{children}</tr>
}

export { TableRow }



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-row.component.tsx